//
//
//
//
//
//

import LinkedCompItem from "~/components/compilations/LinkedCompItem"
export default {
  components: {
    LinkedCompItem
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
}
